export default __webpack_public_path__ + "static/ufo-42e82e220544d9fb960de92144f2f8d5.png";